import { HomeWrap } from "./HomeWrap";
import { HomeCTAButtons } from "./HomeCTAButtons";

export function HomeClosing() {
  return (
    <section className="bg-[#1C130C] py-[86px] text-[#F6EFE4] max-[820px]:py-[60px]">
      <HomeWrap>
        <h2 className="max-w-[17ch] font-display text-[clamp(32px,4.4vw,50px)] font-semibold leading-[1.05] tracking-[-0.015em]">
          Find your spot before you leave the house
        </h2>
        <div data-closing-cta>
          <HomeCTAButtons tone="dark" className="mt-[30px]" />
        </div>
        <p className="mt-4 text-[13.5px] text-[#BFA88E]">Free to download.</p>
      </HomeWrap>
    </section>
  );
}
